'use client';

import { GridItem } from '@hrworks/sui-core/GridItem';

import { S } from '../Layout.styles';
import type { LayoutSidebarProps } from './LayoutSidebar.types';

export const LayoutSidebar = ({ rowGap, children, ...otherProps }: LayoutSidebarProps) => (
  <GridItem size={{ xs: 12, lg: 4, xl: 3 }} {...otherProps}>
    <S.ColumnLayout rowGap={rowGap}>{children}</S.ColumnLayout>
  </GridItem>
);
